import CloseCurrentComposition from 'actions/composition/close_current_composition';

export default function clearCommunicationComposition(context) {
  new CloseCurrentComposition(context).run();
}
